import { memo, useMemo } from 'react';
import { Box } from '@mui/material';
import { getAssetPreviewImage, standardDisplayDimensions } from '../../const';
import CosmosPlayer from 'components/CosmosPlayer/CosmosPlayer';
import { PlayerMetaType } from 'components/CosmosPlayer/types';

const InlineVideoDisplay = memo((asset: any) => {
  const { files, title, remote_video_player, remote_video } = asset;

  const preview = useMemo(() => {
    return getAssetPreviewImage(asset);
  }, [asset]);

  // Memoize video metadata based on asset data
  const videoMeta: PlayerMetaType = useMemo(() => {
    const poster = preview || files?.poster?.url || files?.preview?.url || '';

    const defaultMeta = {
      uniqueId: asset?.uuid || asset?.id,
      type: 'video' as const,
      title: title || 'Video File',
      alt: title || '',
      poster: poster,
    };

    // Determine the source based on available data
    let source: string;

    if (remote_video_player?.includes('iframe')) {
      const iframe = document.createElement('div');
      iframe.innerHTML = remote_video_player;
      source = iframe.querySelector('iframe')?.getAttribute('src') || '';
    } else {
      source =
        files?.video?.url ||
        remote_video?.properties?.mp4_url ||
        remote_video?.properties?.url ||
        '';
    }

    return {
      ...defaultMeta,
      source,
    };
  }, [
    asset?.id,
    asset?.uuid,
    files?.poster?.url,
    files?.preview?.url,
    files?.video?.url,
    preview,
    remote_video?.properties?.mp4_url,
    remote_video?.properties?.url,
    remote_video_player,
    title,
  ]);

  if (!videoMeta.source) {
    return null;
  }

  return (
    <Box sx={{ position: 'relative', minHeight: '10rem', ...standardDisplayDimensions }}>
      <Box
        sx={{
          height: '100%',
        }}
      >
        <CosmosPlayer
          playerMeta={videoMeta}
          height="100%"
        />
      </Box>
    </Box>
  );
});
InlineVideoDisplay.displayName = 'InlineVideoDisplay';

export default InlineVideoDisplay;
